<div
  class="op-modal op-modal_wide confirm-form-submit--modal loading-indicator--location"
  data-indicator-name="modal"
>
  <op-modal-header (close)="closeMe($event)">{{text.board_type}}</op-modal-header>

  <div class="op-modal--body">
    <p
      *ngIf="eeShowBanners"
    >
      <op-enterprise-banner
        [linkMessage]="text.upgrade_to_ee_text"
        [textMessage]="text.teaser_text"
        [moreInfoLink]="text.more_info_ee_link"
        opReferrer="boards"
      ></op-enterprise-banner>
    </p>
    <p
      *ngIf="!eeShowBanners"
      [textContent]="text.select_board_type"></p>
    <section class="new-board--section">
      <tile-view
        [tiles]="available"
        [disable]="inFlight"
        (create)="createBoard($event)">
      </tile-view>
    </section>
  </div>
</div>
